// T134 Artefact 1 — canonical link helper. Returns RR v7 MetaDescriptor[].
import type { MetaDescriptor } from "react-router";
import type { Lang, RouteKey } from "~/config/route-config";
import { absoluteUrl } from "./site";

/**
 * `<link rel="canonical">` for `routeKey` in `locale`. Always absolute, always
 * production-host (see `site.ts`). Never throws.
 */
export function buildCanonical(
  routeKey: RouteKey,
  params: Record<string, string> | undefined,
  locale: Lang,
): MetaDescriptor[] {
  return [
    { tagName: "link", rel: "canonical", href: absoluteUrl(routeKey, locale, params) },
  ];
}
